export const FETCH_CREDITNOTESDETAILS_INIT_ACTION =
  "FETCH_CREDITNOTESDETAILS_INIT_ACTION";
export const FETCH_CREDITNOTESDETAILS_SUCCESS_ACTION =
  FETCH_CREDITNOTESDETAILS_INIT_ACTION + "_SUCCESS";
export const FETCH_CREDITNOTESDETAILS_FAIL_ACTION =
  FETCH_CREDITNOTESDETAILS_INIT_ACTION + "_ERROR";

export function fetchCreditNotes(value) {
  return {
    type: FETCH_CREDITNOTESDETAILS_INIT_ACTION,
    value: value
  };
}
export function pageSelected(value) {
  return {
    type: FETCH_CREDITNOTESDETAILS_INIT_ACTION,
    value: value
  };
}
